// import AccountCircle from '@material-ui/icons/AccountCircle'
// import AddCircle from '@material-ui/icons/AddCircle'
// import CheckCircle from '@material-ui/icons/CheckCircle'
// import ChevronRight from '@material-ui/icons/ChevronRight'
// import DeleteRounded from '@material-ui/icons/DeleteRounded'
// import DoneOutline from '@material-ui/icons/DoneOutline'
// import IconError from '@material-ui/icons/Error'
// import ExpandMore from '@material-ui/icons/ExpandMore'
// import FlightTakeoff from '@material-ui/icons/FlightTakeoff'
// import LastPage from '@material-ui/icons/LastPage'
// import RemoveRedEye from '@material-ui/icons/RemoveRedEye'
// import Sync from '@material-ui/icons/Sync'
import React from 'react'

const style = {
    font24: {
        fontSize: 40,
        color: '#fff',
    },
    font14: {
        fontSize: 16,
        color: '#999',
        marginRight: 2,
    },
}

// export const IconAddCircle = <AddCircle />
export const IconSync = ({cssclass}) => <WebIcon2 name="sync" cssclass={cssclass}/>
export const IconCheckCircle = ({style}) =><WebIcon name="check_circle" style={style}/>
// export const IconSync = <Sync />
// export const IconAccountCircle = <AccountCircle />
export const IconError = ({style}) => <WebIcon name="error" style={style}/>
// export const IconFlightTakeoff = <FlightTakeoff />
export const IconChevronLeft = ({ cssclass }) => <WebIcon name="chevron_left"/>
export const IconChevronRight = () => <WebIcon name="chevron_right"/>

export const IconExpandMore = () => <WebIcon name="expand_more"/>
export const IconLastPage = ({ cssclass }) => <WebIcon name="last_page" />

export const IconSearch = () => <WebIcon name="search"/>

export const Person1 = () => (
    <WebIcon name="assignment_ind" style={style.font24} />
)
export const IconClose = ({style}) => <WebIcon name="close" style={style}/>
export const IconPersonAdd = () =><WebIcon name="person_add"/>
export const AssignmentTurnedIn = () => <WebIcon name="assignment_turned_in"  />
export const IconPrint = ({style}) => <WebIcon name="print" style={style}/>
export const IconAccountBox = ({style}) => <WebIcon name="account_box" style={style}/>
export const IconNextweeek = () => <WebIcon name="next_week" style={style.font24}/>
export const IconStore = () => <WebIcon name="store" style={style.font24}/>
export const IconStars = () => <WebIcon name="stars" style={style.font24}/>
export const IconUpdate = () => <WebIcon name="update" style={style.font14}/>
export const IconEye = () => <WebIcon name="remove_red_eye" style={style.font14}/>
export const IconHome = () => <WebIcon name="home"/>
export const IconRefresh = () =><WebIcon name="refresh" />
export const IconPeople = () => <WebIcon name="recent_actors"/>
export const IconPlace = ({style}) => <WebIcon name="place" style={style}/>
export const IconDeviceHub = () => <WebIcon name="device_hub"/>
export const IconArrowDropDown = () => <WebIcon name="arrow_drop_down" />
export const IconPencil = () => <WebIcon name="create"/>
export const IconForward = () =><WebIcon name="arrow_forward"/>
export const IconDone = ({style}) =><WebIcon name="done" style={style}/>
export const IconNearMe = () => <WebIcon name="near_me"/>
// export const IconPowerSetting = () =><WebIcon name="power_setting"/>
const WebIcon = ({ name, style }) => (
    <i className="material-icons" style={style}>
        { name }
    </i>
)
const WebIcon2 = ({ name, cssclass }) => (
    //with class
    <i className={`material-icons ${cssclass}`}>
        {name}
    </i>
)
